import { useMetamaskWalletAddress } from '@/src/views/states/MetamaskWalletAddress'
import { useMetamaskWalletChainId } from '@/src/views/states/MetamaskWalletChainId'
import { useEffect, useState } from 'react'
import { MetamaskService } from '../../../../services/MetamaskService'
import { useLoginUser } from '../../../states/LoginUser'
import { Props } from './Layout'
import { useRegisterWalletAddressMutation, useRequestWeb3ChallengeMutation } from './query.generated'
import { AuthService } from '@/src/services/AuthService'
import { auth } from '@/src/services/FirebaseService'

export const useProps = (): Props => {
  const { loginUser, reload } = useLoginUser()
  const userWalletAddress = loginUser?.walletAddress ?? ''
  const currentMetamskWalletAddress = useMetamaskWalletAddress().walletAddress
  const chainId = useMetamaskWalletChainId().chainId
  const [state, setState] = useState<Props['state']>({ type: 'INVISIBLE' })
  const [requestWeb3Challenge] = useRequestWeb3ChallengeMutation()
  const [registerWalletAddress] = useRegisterWalletAddressMutation()
  const [visibleLoading, setVisibleLoading] = useState(false)

  useEffect(() => {
    if (!AuthService.isLoggedIn()) {
      setState({ type: 'INVISIBLE' })
    } else if (!currentMetamskWalletAddress || !MetamaskService.isValidAddress(userWalletAddress)) {
      console.warn('User wallet is different from current Metamask wallet. ', {
        userWallet: userWalletAddress,
        MetamskWallet: currentMetamskWalletAddress,
      })
      setState({ type: 'REQUIRED_USER_ACCOUNT_CONNECTED' })
    } else if (currentMetamskWalletAddress !== userWalletAddress) {
      setState({ type: 'WRONG_WALLET_ADDRESS', walletAddress: userWalletAddress })
    } else if (chainId !== process.env.NEXT_PUBLIC_CHAIN_ID) {
      MetamaskService.switchToSupportedChain()
      setState({ type: 'WRONG_CHAIN_ID' })
    } else {
      setState({ type: 'INVISIBLE' })
    }
  }, [userWalletAddress, currentMetamskWalletAddress, chainId])

  return {
    state,
    visibleLoading,
    onClickConnectToMetamsk: async () => {
      setVisibleLoading(true)
      MetamaskService.requestConnectionToMetamsk().then(async (result) => {
        if (!result) {
          setVisibleLoading(false)
        }

        const walletAddress = await MetamaskService.getWalletAddress()
        if (!MetamaskService.isValidAddress(userWalletAddress)) {
          requestWeb3Challenge({
            variables: {
              input: {
                chain: process.env.NEXT_PUBLIC_WEB3_CHALLENGE_CHAIN_ID,
                walletAddress,
              },
            },
          })
            .then(async (res) => {
              if (res.errors) {
                const errorMessage = res?.errors?.[0]?.message ? res.errors[0].message : ''
                return alert(`Error : Connect failed.\n${errorMessage}`)
              }

              const message = res.data?.RequestWeb3Challenge.message ?? ''
              const signature = await MetamaskService.signMessage(message)

              registerWalletAddress({ variables: { input: { message, signature } } })
                .then(async () => {
                  await auth.currentUser?.getIdToken(true)
                  await reload()
                  setVisibleLoading(false)
                })
                .catch((e) => {
                  alert('Error : ' + e.message)
                  setVisibleLoading(false)
                })
            })
            .catch(() => {
              setVisibleLoading(false)
            })
        }
      })
    },
  }
}
